var _style, _defs, _defs2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolmetexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.9 83.1",
    style: {
      enableBackground: "new 0 0 291.9 83.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000042730605166338721630000018083355003150805145_);}\r\n\t.st1{fill:url(#Path_9_00000006669246625119025330000017842601744487559552_);}\r\n\t.st2{clip-path:url(#SVGID_00000069357614266126613730000004883330606585829266_);}\r\n\t.st3{fill:url(#Path_11_00000038414425372499846190000012058410427002706576_);}\r\n\t.st4{fill:#231F20;}\r\n\t.st5{fill:#1A1718;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Solmetex-Logo",
    transform: "translate(-5.998 -11.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    transform: "translate(5.998 11.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    transform: "translate(24.653)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M22.3,22.8c-7.1,10-4.3,17.1-1,21.2c1.7,2.1,11.6,10.7,21-0.7c5.7-6.9,0.6-14.8,6-21.3 c2.9-3.4,7.6-5.6,10.3-6.6c1.5-0.5,2.8-1.1,1.9-1.6c-0.3-0.3-5.1-1.3-11.3-1.3C40.7,12.5,29.2,14.5,22.3,22.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096753890870104302330000015783072162615563953_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    style: {
      clipPath: "url(#SVGID_00000096753890870104302330000015783072162615563953_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_9_00000122716520461155042150000001548991412889460871_",
    cx: -17.6805,
    cy: 1074.4347,
    r: 0.222,
    gradientTransform: "matrix(-24.7987 -67.4972 67.4995 -24.7993 -72338.0703 25893.7383)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40AAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#157DC1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    style: {
      fill: "url(#Path_9_00000122716520461155042150000001548991412889460871_)"
    },
    d: "M20.8,69.5l-19.1-52 L55.9-2.4L75,49.6L20.8,69.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    transform: "translate(0 27.99)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000026873724919098704460000002367294751376327851_",
    d: "M17.9,25.9c0.1,5.2,2.6,12.5,14.5,15.5 c18.4,3.3,34.8-16.8,35-17.9c0.3-0.9-1-0.5-2.5,0.1c-2.6,1-7.7,2.4-12.1,1.6c-8.3-1.4-9.5-10.8-18.4-12.3 c-1.2-0.2-2.4-0.3-3.6-0.3C19.5,12.5,17.9,23.5,17.9,25.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140734263377689004230000004700103116852966533_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026873724919098704460000002367294751376327851_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    style: {
      clipPath: "url(#SVGID_00000140734263377689004230000004700103116852966533_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Path_11_00000106129169997294561790000007566082750996862116_",
    cx: -4.8064,
    cy: 1045.7528,
    r: 0.241,
    gradientTransform: "matrix(22.1665 60.4265 60.4285 -22.2014 -62658.2578 23651.373)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40AAE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#157DC1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    style: {
      fill: "url(#Path_11_00000106129169997294561790000007566082750996862116_)"
    },
    d: "M7.5,16.4l16.3,44.4 l54.2-20L61.8-3.6L7.5,16.4z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    transform: "translate(67.524 15.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st4",
    d: "M20.4,36.3c0,0,3.1,3.7,7.6,3.6c2.8,0,5.2-1.7,5.2-4.5c0-6.3-14.7-5.3-14.7-14.8 c0-4.6,4-8.1,9.7-8.1c3.2,0,8.6,1.4,8.7,5.5v2.5h-4v-1.4c0-1.6-2.3-2.7-4.7-2.7c-3.3,0-5.3,1.8-5.3,4.1c0,6.1,14.6,4.8,14.6,14.7 c0,4.7-3.6,8.6-9.6,8.7c-3.8,0-7.5-1.7-10.1-4.5L20.4,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    className: "st4",
    d: "M52.7,21.1c6.5,0,11.7,4.8,11.7,11.3c0.2,6.5-4.8,11.9-11.3,12.1c-6.5,0.2-11.9-4.8-12.1-11.3 c-0.2-6.5,4.8-11.9,11.3-12.1C52.5,21.1,52.6,21.1,52.7,21.1 M52.7,40.2c4.3,0.2,7.9-3.2,8.1-7.5c0.2-4.3-3.2-7.9-7.5-8.1 c-4.3-0.2-7.9,3.2-8.1,7.5c0,0.1,0,0.2,0,0.3c-0.1,4.2,3.2,7.7,7.3,7.8C52.6,40.2,52.7,40.2,52.7,40.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    className: "st4",
    d: "M69.1,17.5c0.1-0.5-0.3-0.9-0.7-0.9c-0.1,0-0.1,0-0.2,0h-1.8v-3.6h4.1c1.9,0,2.8,0.8,2.8,2.7 l0.1,23.1c-0.1,0.5,0.3,0.9,0.7,0.9c0.1,0,0.1,0,0.2,0h1.8v3.6H72c-1.9,0-2.7-0.8-2.8-2.7L69.1,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    className: "st4",
    d: "M80.8,26c0.1-0.5-0.3-0.9-0.7-0.9c-0.1,0-0.1,0-0.2,0h-1.8v-3.6h4c1.9,0,2.7,0.8,2.8,2.4v0.8 c0,0.7,0,1.2,0,1.2h0.1c1.3-3,4.2-4.9,7.4-5c3.7,0,5.8,1.7,6.5,4.9H99c1.4-3,4.4-4.9,7.7-5c4.9,0,7.2,2.8,7.2,8.3v9.4 c-0.1,0.5,0.3,0.9,0.7,0.9c0.1,0,0.1,0,0.2,0h1.8v3.6h-4.1c-1.9,0-2.7-0.8-2.8-2.7V30.1c0-3.1-0.6-5.4-3.8-5.4 c-3,0-5.3,2.6-6.1,5.6c-0.2,1-0.3,2-0.3,3v9.9h-4.2l0-13c0-2.8-0.4-5.4-3.8-5.4c-3.2,0-5.4,2.7-6.2,5.7c-0.2,0.9-0.3,1.8-0.3,2.8 v9.9h-4.2L80.8,26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    className: "st4",
    d: "M129.8,20.9c6.1,0,9.4,4.5,9.4,10.2c0,0.5-0.1,1.7-0.1,1.7l-15.9,0.1c0,4,3.3,7.2,7.3,7.2 c0.1,0,0.1,0,0.2,0c2.3-0.1,4.6-1,6.3-2.5l1.8,3c-2.3,2-5.3,3.2-8.4,3.2c-6.9,0-11.5-4.9-11.6-11.3 C118.9,25.4,123.6,20.9,129.8,20.9 M134.9,29.7c-0.1-3.6-2.4-5.5-5.1-5.5c-3.2-0.1-6,2.3-6.4,5.5H134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    className: "st4",
    d: "M144.8,24.7H142v-3.4h2.9v-5.9h4.1v5.9h5.2v3.4H149v10c0,4.4,3,4.9,4.6,4.9c0.3,0,0.7,0,1-0.1 v3.7c-0.5,0.1-1,0.1-1.4,0.1c-2.7,0-8.3-0.8-8.3-8.1L144.8,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    className: "st4",
    d: "M168.2,20.8c6.1,0,9.4,4.5,9.4,10.2c0,0.5-0.1,1.7-0.1,1.7l-15.9,0.1c0,4,3.3,7.2,7.3,7.2 c0.1,0,0.1,0,0.2,0c2.3-0.1,4.6-1,6.3-2.5l1.8,3c-2.3,2-5.3,3.2-8.4,3.2c-6.9,0-11.5-4.9-11.6-11.3 C157.3,25.3,162,20.8,168.2,20.8 M173.3,29.6c-0.1-3.6-2.4-5.5-5.1-5.5c-3.2-0.1-6,2.3-6.4,5.5H173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    className: "st4",
    d: "M187.5,31.8l-4.2-6.2c-0.4-0.6-1.1-0.9-1.8-0.8h-1.2v-3.6h2.7c2,0,2.6,0.4,3.8,2.2l2.7,4.2 c0.3,0.5,0.7,1.4,0.7,1.4h0.1c0,0,0.4-0.8,0.7-1.4l2.6-4.2c1.1-1.8,1.7-2.2,3.8-2.2h2.7v3.6h-1.2c-0.7-0.1-1.4,0.2-1.8,0.8 l-4.2,6.2l7.4,11.1h-4.7l-4.6-7.1c-0.3-0.5-0.6-1.1-0.6-1.1h-0.1c0,0-0.3,0.6-0.7,1.1L185,43h-4.7L187.5,31.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    className: "st5",
    d: "M277.8,49.4c-0.1,0-0.3-0.1-0.4-0.1h-0.2v0.8h0.3c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.1-0.3 C278,49.6,277.9,49.5,277.8,49.4 M276.5,51.7l0-2.8l0.8,0c0.3,0,0.5,0,0.6,0c0.2,0,0.4,0.1,0.6,0.1c0.2,0.1,0.4,0.4,0.4,0.7 c0,0.2,0,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c0.1,0,0.3,0.1,0.4,0.2c0.2,0.2,0.3,0.4,0.3,0.6v0.2c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1l0,0.1l-0.7,0c0-0.1,0-0.3-0.1-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0-0.3,0l-0.2,0h-0.2l0,1 L276.5,51.7z M276.1,48.8c-0.8,0.8-0.8,2.1,0,2.9c0.4,0.4,0.9,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6c0.8-0.8,0.8-2.1,0-2.9 C278.2,48,276.9,48,276.1,48.8C276.1,48.8,276.1,48.8,276.1,48.8 M279.3,52.1c-1,1-2.6,1-3.5,0c-0.5-0.5-0.7-1.1-0.7-1.8 c0-0.7,0.3-1.4,0.8-1.8c0.5-0.4,1.1-0.7,1.7-0.7c1.4,0,2.5,1.1,2.5,2.5C280,50.9,279.8,51.6,279.3,52.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolmetexLogo);
export default __webpack_public_path__ + "static/media/Solmetex_logo.8f4dba81e374514bdccffa97f4f88358.svg";
export { ForwardRef as ReactComponent };